import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// import { images } from '../../constants';
import { urlFor, client } from '../../client';

import { AppWrap, MotionWrap} from '../../wrapper';

import './About.scss'

// const abouts = [
//   {title: "Web Development", description: "", imgUrl: images.about01},
//   {title: "Mobile App Programming", description: "", imgUrl: images.about02},
//   {title: "Backend Development", description: "", imgUrl: images.about03},
//   {title: "Cybersecurity", description: "", imgUrl: images.about04},
// ]

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);
  return (
    <>
      <h2 className="head-text">"Programming isn't about<span> what you know; </span> <br />it's about what <span>you can figure out."</span></h2>
      <span className="quote-author">– Chris Pine</span>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  )
}


export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);